/** @jsxImportSource @emotion/react */

import React from 'react';
import Account from '@component/iyagigo/hub/account';
import PageTemplate from '@page/iyagigo/page-template';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { useNavigate } from 'react-router-dom';

const AccountPage: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <PageTemplate
      title='계정관리'
      mode={'back'}
      handleNavigationClick={() => navigate(IYAGIGO_PATH.HUB_HOME_PATH)}
      // handleNavigationClick={() => {
      //   if (location.key !== 'default') {
      //     navigate(-1);
      //   } else {
      //     navigate(IYAGIGO_PATH.HUB_HOME_PATH);
      //   }
      //   // dispatch(navigationActions.openMobileSideTab());
      // }}
    >
      <Account />
    </PageTemplate>
  );
};

export default AccountPage;
